module.exports = "<div *ngIf=\"selectedStocks.length > 0\">\n  <nvd3 #nvd3Chart [options]=\"options\" [data]=\"data\"></nvd3>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/travis/build/nishant95/stocks-app/src/app/modules/line-chart/line-chart.component.html
// module id = ../../../../../src/app/modules/line-chart/line-chart.component.html
// module chunks = main